import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button, Card, Alert } from "react-bootstrap";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import OrientationPrompt from "../components/OrientationPrompt";
import SchoolRollNumberInput from "../components/SchoolRollNumberInput";
import SwapStudentsAssessmentModal from "../components/SwapStudentsAssessmentModal";
import SendStudentLoginsModal from "../components/SendStudentLoginsModal";
import DeleteClassesModal from "../components/DeleteClassesModal";
import DeleteStudentsModal from "../components/DeleteStudentsModal";
import StudentTransfersModal from "../components/StudentTransfersModal";
import GroupStudentTransfersModal from "../components/GroupStudentTransfersModal";
import RemoveTeacherFromClass from "../components/RemoveTeacherFromClass";
import MarkClassAsFakeModal from "../components/MarkClassAsFakeModal";
import GradeChangeManagementModal from "../components/GradeChangeManagementModal";
import AddStudentsModal from "../components/AddStudentsModal";
import CreateClassesModal from "../components/CreateClassesModal";
import ClassOwnershipModal from "../components/ClassOwnershipModal";
import ShareClassWithTeachersModal from "../components/ShareClassWithTeachersModal";
import ClassroomEditModal from "../components/ClassroomEditModal";
import RepeatingStudentsModal from "../components/RepeatingStudentsModal";
import ClassTransitionWorkflowModal from "../components/ClassTransitionWorkflowModal";
import EditStudentsModal from "../components/EditStudentsModal";

// Add the new comparison modal imports
import {
  RepeatingStudentComparisonModal,
  RetakeScreeningComparisonModal,
  RetakeTaskComparisonModal,
  RTIComparisonModal
} from "../components/ComparisonModals";
import ClassConversionMethodModal from "../components/ClassConversionMethodModal";

// Add the Data Recovery modal imports
import RestoreDeletedClassesModal from "../components/RestoreDeletedClassesModal";
import RestoreDeletedStudentsModal from "../components/RestoreDeletedStudentsModal";
import RestoreDeletedTeachersModal from "../components/RestoreDeletedTeachersModal";
import RestoreArchivedAssessmentsModal from "../components/RestoreArchivedAssessmentsModal";
import RestoreDeletedAnswersModal from "../components/RestoreDeletedAnswersModal";

import "../components/ClassCard.css";
import {
  FaChalkboardTeacher,
  FaExchangeAlt,
  FaPlus,
  FaTrash,
  FaUserPlus,
  FaUserMinus,
  FaEnvelope,
  FaArrowsAltH,
  FaGraduationCap,
  FaRedo,
  FaFlag,
  FaShare,
  FaCrown,
  FaEdit,
  FaUsers,
  FaRoute,
  FaChartLine,
  FaRedoAlt,
  FaTasks,
  FaStethoscope,
  FaTrashRestore,
  FaUserCheck,
  FaClipboardList,
  FaPencilAlt
} from "react-icons/fa";

import {
  whoami,
  getClasses,
  getClassesBySchoolId,
  getTeachersBySchoolId,
  getSchools,
  getCountryGrades,
  shareClass,
  unShareClass,
  swapAssessmentStudents,
  transferAssessmentToStudent,
  softDeleteClass,
  getQR,
  updateTrialStatusBatch,
  getStudentsBySchoolId,
  bulkUpdateStudentClassId,
  bulkUpdateClassGrades,
  addStudents,
  createBulkClasses,
  bulkRemoveOrReplaceClassOwner,
  getSharedTeachersByClassId,
  getSharedClassDetailsByClassId,
  editClass,
  markStudentAsRepeat,
  batchDeleteStudents,
  createClassConversionMethod,
  updateClassConversionMethod,
  getClassConversionMethodBySchoolId,
  updateStudent,
  getDeletedClassesBySchool,
  restoreClass,
  batchRestoreClasses,
  getDeletedStudentsBySchool,
  restoreStudent,
  batchRestoreStudents,
  getDeletedTeachersBySchool,
  restoreTeacher,
  batchRestoreTeachers,
  getArchivedAssessmentsBySchool,
  restoreArchivedAssessment,
  batchRestoreArchivedAssessments,
  getDeletedAnswersBySchool,
  restoreAnswer,
  batchRestoreAnswers
} from "../services/APIClient";
import { isTeacher } from "../utils/auth"; // ✅ Import role checker

function ClassAdmin() {
  // CS Agent/Operator information - separate from target school
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("John Doe");

  // Target school information
  const [schoolid, setSchoolid] = useState("");
  const [schoolName, setSchoolName] = useState("Loading school information...");
  const [rollnumber, setRollnumber] = useState("");

  const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);
  const [isLoadingSchool, setIsLoadingSchool] = useState(true);
  const [loadError, setLoadError] = useState(null);

  // ✅ Check if current user is a teacher
  const teacherMode = isTeacher();

  // Check if school has been found
  const isSchoolFound = schoolid && schoolid !== "" && schoolName !== "Loading school information..." && schoolName !== "Please enter school roll number and press 'Find School'";

  const [showModal, setShowModal] = useState({
    removeTeacherFromClass: false,
    shareClassWithTeachers: false,
    swapStudents: false,
    createClasses: false,
    deleteClasses: false,
    classOwnership: false,
    classroomEdit: false,
    addingStudents: false,
    editStudents: false,
    deletingStudents: false,
    sendingLogins: false,
    studentTransfers: false,
    groupStudentTransfers: false,
    gradeChangeManagement: false,
    repeatingStudents: false,
    markClassAsFake: false,
    classTransitionWorkflow: false,
    classConversionMethod: false,
    repeatingStudentComparison: false,
    retakeScreeningComparison: false,
    retakeTaskComparison: false,
    rtiComparison: false,
    restoreClasses: false,
    restoreStudents: false,
    restoreTeachers: false,
    restoreArchivedAssessments: false,
    restoreDeletedAnswers: false,
  });

  // Handler for when target school ID is retrieved from search
  const handleSchoolIdRetrieved = (targetSchoolId) => {
    console.log("Target School ID updated:", targetSchoolId);
    setSchoolid(targetSchoolId);
  };

  // Handler for when target school name is retrieved from search
  const handleSchoolNameRetrieved = (targetSchoolName, rollNum) => {
    console.log("Target School Name updated:", targetSchoolName);
    setSchoolName(targetSchoolName);
    if (rollNum) setRollnumber(rollNum);
  };

  // Temporary implementation if the API function doesn't exist yet
  const handleBulkRemoveOrReplaceClassOwner = async (classIds, newOwnerId) => {
    try {
      if (typeof bulkRemoveOrReplaceClassOwner === 'function') {
        return await bulkRemoveOrReplaceClassOwner(classIds, newOwnerId);
      } else {
        console.warn('bulkRemoveOrReplaceClassOwner function not implemented yet');
        return {
          successful: classIds.map(id => ({ classId: id })),
          failed: []
        };
      }
    } catch (error) {
      console.error('Error in bulk ownership operation:', error);
      throw error;
    }
  };

  const handleUnshareClass = async (classId, teacherId) => {
    try {
      return await unShareClass(classId, teacherId);
    } catch (error) {
      console.error('Error in unshare class operation:', error);
      throw error;
    }
  };

  const handleShareClass = async (classId, teacherId, isSpecialCondition = false) => {
    try {
      return await shareClass(classId, teacherId, isSpecialCondition);
    } catch (error) {
      console.error('Error in share class operation:', error);
      throw error;
    }
  };

  const handleGetClassSharedTeachers = async (classId) => {
    try {
      const sharedTeachers = await getSharedTeachersByClassId(classId);
      return sharedTeachers;
    } catch (error) {
      console.error('Error getting shared teachers:', error);
      throw error;
    }
  };

  const handleUpdateClassName = async (classId, newName) => {
    try {
      const classes = await getClassesBySchoolId(schoolid);
      const currentClass = classes.find(c => c.id === classId);

      if (!currentClass) {
        throw new Error('Class not found');
      }

      let currentGradeLevel = 1;
      if (currentClass.grade_level1) currentGradeLevel = 1;
      else if (currentClass.grade_level2) currentGradeLevel = 2;
      else if (currentClass.grade_level3) currentGradeLevel = 3;
      else if (currentClass.grade_level4) currentGradeLevel = 4;
      else if (currentClass.grade_level5) currentGradeLevel = 5;
      else if (currentClass.grade_level6) currentGradeLevel = 6;
      else if (currentClass.grade_level7) currentGradeLevel = 7;
      else if (currentClass.grade_level8) currentGradeLevel = 8;

      return await editClass(classId, newName, currentGradeLevel);
    } catch (error) {
      console.error('Error in update class name operation:', error);
      throw error;
    }
  };

  // ✅ Admin functions configuration with workflow-based categories
  const getAdminFunctions = () => {
    const allFunctions = [
      {
        category: "Start of Year",
        description: "Set up your school for the new academic year",
        items: [
          {
            name: "Create Classes",
            key: "createClasses",
            icon: FaPlus,
            description: "Set up new classes for the school",
            color: "#3b82f6"
          },
          {
            name: "Add Students",
            key: "addingStudents",
            icon: FaUserPlus,
            description: "Add new students to classes",
            color: "#10b981"
          },
          {
            name: "Send/Download Student Logins",
            key: "sendingLogins",
            icon: FaEnvelope,
            description: "Send Student Bypass Logins to access games",
            color: "#84cc16"
          }
        ]
      },
      {
        category: "Everyday Tasks",
        description: "Common day-to-day administrative actions",
        items: [
          {
            name: "Edit Students",
            key: "editStudents",
            icon: FaEdit,
            description: "Update student information and settings",
            color: "#3b82f6"
          },
          {
            name: "Classroom Edit",
            key: "classroomEdit",
            icon: FaEdit,
            description: "Edit classroom names and details",
            color: "#06b6d4"
          },
          {
            name: "Class Ownership",
            key: "classOwnership",
            icon: FaCrown,
            description: "Manage class ownership and permissions",
            color: "#f59e0b"
          }
        ]
      },
      {
        category: "Moving Students",
        description: "Transfer students between classes or swap assessments",
        items: [
          {
            name: "Student Transfers",
            key: "studentTransfers",
            icon: FaArrowsAltH,
            description: "Transfer individual students between classes",
            color: "#8b5cf6"
          },
          {
            name: "Group Student Transfers",
            key: "groupStudentTransfers",
            icon: FaUsers,
            description: "Transfer multiple students at once",
            color: "#8b5cf6"
          },
          {
            name: "Swap Student Assessments",
            key: "swapStudents",
            icon: FaExchangeAlt,
            description: "Transfer assessments between students",
            color: "#f59e0b"
          }
        ]
      },
      {
        category: "Working with Other Teachers",
        description: "Manage teacher access and collaboration",
        items: [
          {
            name: "Share Class with Teacher/s",
            key: "shareClassWithTeachers",
            icon: FaShare,
            description: "Share classes with teachers for collaboration",
            color: "#10b981"
          },
          {
            name: "Remove Teacher from Class",
            key: "removeTeacherFromClass",
            icon: FaChalkboardTeacher,
            description: "Remove teachers from specific classes",
            color: "#ef4444"
          }
        ]
      },
      {
        category: "End of Year",
        description: "Manage grade transitions and year-end processes",
        items: [
          {
            name: "Grade Change Management",
            key: "gradeChangeManagement",
            icon: FaGraduationCap,
            description: "Manage grade transitions and promotions",
            color: "#06b6d4"
          },
          {
            name: "Repeating Students",
            key: "repeatingStudents",
            icon: FaRedo,
            description: "Manage students repeating grades",
            color: "#6b7280"
          },
          {
            name: "Mark Class Conversion Method",
            key: "classConversionMethod",
            icon: FaRoute,
            description: "Record which conversion method a teacher selected",
            color: "#8b5cf6",
            alpacaStaffOnly: true // ✅ Staff only
          }
        ]
      },
      {
        category: "Corrections & Cleanup",
        description: "Remove or fix incorrect data",
        items: [
          {
            name: "Delete Students",
            key: "deletingStudents",
            icon: FaUserMinus,
            description: "Remove students from the system",
            color: "#ef4444"
          },
          {
            name: "Delete Classes",
            key: "deleteClasses",
            icon: FaTrash,
            description: "Remove classes from the system",
            color: "#ef4444"
          },
          {
            name: "Mark Classes as Fake",
            key: "markClassAsFake",
            icon: FaFlag,
            description: "Mark classes as fake or real classes",
            color: "#f59e0b",
            alpacaStaffOnly: true // ✅ Staff only
          }
        ]
      },
      // ✅ Staff-only sections below
      {
        category: "Advanced Workflows",
        description: "Complete workflows for complex operations",
        alpacaStaffOnly: true,
        items: [
          {
            name: "Class Transition Workflow",
            key: "classTransitionWorkflow",
            icon: FaRoute,
            description: "Complete workflow for class creation and student transitions",
            color: "#8b5cf6"
          }
        ]
      },
      {
        category: "Data Recovery",
        description: "Restore deleted or archived data",
        alpacaStaffOnly: true,
        items: [
          {
            name: "Restore Deleted Classes",
            key: "restoreClasses",
            icon: FaTrashRestore,
            description: "Recover accidentally deleted classes",
            color: "#10b981"
          },
          {
            name: "Restore Deleted Students",
            key: "restoreStudents",
            icon: FaUserCheck,
            description: "Recover accidentally deleted students",
            color: "#3b82f6"
          },
          {
            name: "Restore Deleted Teachers",
            key: "restoreTeachers",
            icon: FaChalkboardTeacher,
            description: "Recover accidentally deleted teachers",
            color: "#f59e0b"
          },
          {
            name: "Restore Archived Assessments",
            key: "restoreArchivedAssessments",
            icon: FaClipboardList,
            description: "Recover archived assessment instances",
            color: "#8b5cf6"
          },
          {
            name: "Restore Deleted Answers",
            key: "restoreDeletedAnswers",
            icon: FaPencilAlt,
            description: "Recover deleted individual answers",
            color: "#ef4444"
          }
        ]
      },
      {
        category: "Assessment Comparisons",
        description: "Compare assessment results across different scenarios",
        alpacaStaffOnly: true,
        items: [
          {
            name: "Repeating Student Comparison",
            key: "repeatingStudentComparison",
            icon: FaChartLine,
            description: "Compare results across years for repeating students",
            color: "#8b5cf6"
          },
          {
            name: "Retake Screening Point Comparison",
            key: "retakeScreeningComparison",
            icon: FaRedoAlt,
            description: "Compare original vs retake results",
            color: "#f59e0b"
          },
          {
            name: "Retake Task Comparison",
            key: "retakeTaskComparison",
            icon: FaTasks,
            description: "Compare individual task attempts",
            color: "#10b981"
          },
          {
            name: "RTI Comparison",
            key: "rtiComparison",
            icon: FaStethoscope,
            description: "Compare standard vs RTI intervention results",
            color: "#ef4444"
          }
        ]
      }
    ];

    // ✅ Filter for teachers
    if (teacherMode) {
      return allFunctions
        .filter(category => !category.alpacaStaffOnly)
        .map(category => ({
          ...category,
          items: category.items.filter(item => !item.alpacaStaffOnly)
        }))
        .filter(category => category.items.length > 0);
    }

    return allFunctions;
  };

  const adminFunctions = getAdminFunctions();

  const handleOpenModal = (modalName) => {
    console.log(`Opening modal: ${modalName} for target school ID: ${schoolid}`);
    setShowModal((prev) => ({ ...prev, [modalName]: true }));
  };

  const handleCloseModal = (modalName) => {
    setShowModal((prev) => ({ ...prev, [modalName]: false }));
  };

  // ✅ Fetch school information based on role
  useEffect(() => {
    const fetchUserAndSchoolInfo = async () => {
      try {
        const response = await whoami();
        console.log("CS Agent/Operator info:", response);
        const stakeholder = response.data.stakeholder;
        setTeacherid(stakeholder.id);
        setName(stakeholder.name);

        // ✅ TEACHER MODE: Auto-load their school
        if (teacherMode) {
          const teacherSchoolId = stakeholder.schoolid || stakeholder.schoolId;
          
          if (!teacherSchoolId) {
            console.error("❌ Teacher has no school ID!");
            setSchoolName("Error: No school assigned");
            setLoadError("No school assigned to your account");
            setIsLoadingSchool(false);
            return;
          }

          console.log("🏫 Teacher mode: Auto-loading school ID:", teacherSchoolId);
          setSchoolid(teacherSchoolId);

          // Fetch school details
          try {
            const response = await getSchools();
            const schools = response.data || response;
            const teacherSchool = Array.isArray(schools) 
              ? schools.find(s => s.id === teacherSchoolId)
              : null;
            
            if (teacherSchool) {
              setSchoolName(teacherSchool.name);
              setRollnumber(teacherSchool.rollnumber || "");
              console.log("✅ Loaded teacher's school:", teacherSchool.name);
            } else {
              setSchoolName("School not found");
              setLoadError("School not found in database");
            }
          } catch (error) {
            console.error("❌ Error fetching school details:", error);
            setSchoolName("Error loading school");
            setLoadError(`Error loading school: ${error.message}`);
          }

          setIsLoadingSchool(false);
        } else {
          // ✅ ALPACA-STAFF MODE: Show search interface
          setSchoolName("Please enter school roll number and press 'Find School'");
          setIsLoadingSchool(false);
        }
      } catch (error) {
        console.error("❌ Error in whoami:", error);
        setSchoolName("Error loading user information");
        setLoadError(`Error loading user: ${error.message}`);
        setIsLoadingSchool(false);
      }
    };

    fetchUserAndSchoolInfo();
  }, [teacherMode]);

  const AdminFunctionCard = ({ item }) => (
    <Card
      className="class-admin-card"
      onClick={() => handleOpenModal(item.key)}
      style={{ cursor: 'pointer' }}
    >
      <Card.Body className="class-admin-card-body">
        <div className="class-admin-icon" style={{ backgroundColor: `${item.color}15`, color: item.color }}>
          <item.icon size={20} />
        </div>
        <div className="class-admin-content">
          <h6 className="class-admin-title">{item.name}</h6>
          <p className="class-admin-description">{item.description}</p>
        </div>
      </Card.Body>
    </Card>
  );

  return (
    <div>
      <style jsx>{`
        .category-header {
          margin-bottom: 1rem;
        }
        
        .category-title {
          margin-bottom: 0.25rem;
        }
        
        .category-description {
          font-size: 0.9rem;
          margin-bottom: 0;
          font-style: italic;
        }
        
        .function-category {
          margin-bottom: 2.5rem;
        }
      `}</style>
      <Container fluid className="class-admin-container">
        <HeadingBanner name={`Welcome ${name}!`} isLoggedIn={true} cloud={true} teacherid={teacherid} />

        <Row className="class-admin-row">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="class-admin-content">

            <div className="class-admin-header">
              <h2 className="class-admin-page-title">Class Administration</h2>
              <p className="class-admin-page-subtitle">
                {teacherMode 
                  ? "Manage classes, students, and teachers for your school"
                  : "Manage classes, students, and teachers for your school"
                }
              </p>
            </div>

            {/* ✅ ROLE INDICATOR */}
            {/* {teacherMode && (
              <Alert variant="info" className="mb-4">
                <strong>👨‍🏫 School Administrator Mode</strong>
                <p className="mb-0">You are managing your school. All actions are restricted to your school only.</p>
              </Alert>
            )} */}

            {/* ✅ ERROR DISPLAY */}
            {loadError && (
              <Alert variant="danger" className="mb-4">
                <strong>⚠️ Error Loading School</strong>
                <p className="mb-0">{loadError}</p>
              </Alert>
            )}

            {/* ✅ SCHOOL SELECTOR */}
            <div className="school-selector-section">
              {teacherMode ? (
                // ✅ TEACHER VIEW: Show their school (locked)
                <div className="selected-school locked-school">
                  <Alert variant="secondary" className="mb-3">
                    <FaChalkboardTeacher className="me-2" />
                    You are managing the following school:
                  </Alert>
                  {isLoadingSchool ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading your school information...</p>
                    </div>
                  ) : (
                    <>
                      <h3 className="school-name">{schoolName}</h3>
                      {rollnumber && (
                        <p className="text-muted">Roll Number: {rollnumber}</p>
                      )}
                    </>
                  )}
                </div>
              ) : (
                // ✅ ALPACA-STAFF VIEW: Show search interface
                <>
                  <SchoolRollNumberInput
                    onSchoolIdRetrieved={handleSchoolIdRetrieved}
                    schoolNameRetrieved={handleSchoolNameRetrieved}
                  />
                  <div className="selected-school">
                    <h3 className="school-name">{schoolName}</h3>
                    {isSchoolFound && (
                      <p className="text-muted">School ID: {schoolid} | CS Agent ID: {teacherid}</p>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Only show admin functions if school has been found */}
            {isSchoolFound && (
              <div className="admin-functions-container">
                {adminFunctions.map((category, categoryIndex) => (
                  <div key={categoryIndex} className="function-category">
                    <div className="category-header">
                      <h4 className="category-title">{category.category}</h4>
                      {category.description && (
                        <p className="category-description text-muted">{category.description}</p>
                      )}
                    </div>
                    <div className="function-cards-grid">
                      {category.items.map((item, itemIndex) => (
                        <AdminFunctionCard key={itemIndex} item={item} />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Show message when no school selected */}
            {!isSchoolFound && !isLoadingSchool && (
              <div className="no-school-message" style={{
                textAlign: 'center',
                padding: '2rem',
                color: '#6b7280',
                fontSize: '1.1rem'
              }}>
                {teacherMode 
                  ? loadError || "Unable to load school information. Please contact support."
                  : "Please select a school to access administration functions."
                }
              </div>
            )}

          </Col>
        </Row>
      </Container>

      {isPortrait && <OrientationPrompt />}

      {/* All modals - only render when shown */}
      {isSchoolFound && (
        <>
          {/* Data Recovery Modals - Staff only */}
          {!teacherMode && showModal.restoreClasses && (
            <RestoreDeletedClassesModal
              show={showModal.restoreClasses}
              onHide={() => handleCloseModal('restoreClasses')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
              getDeletedClassesBySchool={getDeletedClassesBySchool}
              restoreClass={restoreClass}
              batchRestoreClasses={batchRestoreClasses}
            />
          )}

          {!teacherMode && showModal.restoreStudents && (
            <RestoreDeletedStudentsModal
              show={showModal.restoreStudents}
              onHide={() => handleCloseModal('restoreStudents')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
              getDeletedStudentsBySchool={getDeletedStudentsBySchool}
              restoreStudent={restoreStudent}
              batchRestoreStudents={batchRestoreStudents}
            />
          )}

          {!teacherMode && showModal.restoreTeachers && (
            <RestoreDeletedTeachersModal
              show={showModal.restoreTeachers}
              onHide={() => handleCloseModal('restoreTeachers')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
              getDeletedTeachersBySchool={getDeletedTeachersBySchool}
              restoreTeacher={restoreTeacher}
              batchRestoreTeachers={batchRestoreTeachers}
            />
          )}

          {!teacherMode && showModal.restoreArchivedAssessments && (
            <RestoreArchivedAssessmentsModal
              show={showModal.restoreArchivedAssessments}
              onHide={() => handleCloseModal('restoreArchivedAssessments')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
              getArchivedAssessmentsBySchool={getArchivedAssessmentsBySchool}
              restoreArchivedAssessment={restoreArchivedAssessment}
              batchRestoreArchivedAssessments={batchRestoreArchivedAssessments}
            />
          )}

          {!teacherMode && showModal.restoreDeletedAnswers && (
            <RestoreDeletedAnswersModal
              show={showModal.restoreDeletedAnswers}
              onHide={() => handleCloseModal('restoreDeletedAnswers')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
              getDeletedAnswersBySchool={getDeletedAnswersBySchool}
              restoreAnswer={restoreAnswer}
              batchRestoreAnswers={batchRestoreAnswers}
            />
          )}

          {/* Teacher Management Modals */}
          {showModal.shareClassWithTeachers && (
            <ShareClassWithTeachersModal
              show={showModal.shareClassWithTeachers}
              onHide={() => handleCloseModal('shareClassWithTeachers')}
              schoolid={schoolid}
              getTeachers={getTeachersBySchoolId}
              getClassesBySchoolId={getClassesBySchoolId}
              shareClass={handleShareClass}
              unshareClass={handleUnshareClass}
              getClassSharedTeachers={handleGetClassSharedTeachers}
            />
          )}

          {showModal.removeTeacherFromClass && (
            <RemoveTeacherFromClass
              show={showModal.removeTeacherFromClass}
              onHide={() => handleCloseModal('removeTeacherFromClass')}
              schoolid={schoolid}
              swapAssessmentStudents={swapAssessmentStudents}
            />
          )}

          {/* Student Management Modals */}
          {showModal.swapStudents && (
            <SwapStudentsAssessmentModal
              show={showModal.swapStudents}
              onHide={() => handleCloseModal('swapStudents')}
              schoolid={schoolid}
              swapAssessmentStudents={swapAssessmentStudents}
              transferAssessmentToStudent={transferAssessmentToStudent}
            />
          )}

          {showModal.addingStudents && (
            <AddStudentsModal
              show={showModal.addingStudents}
              onHide={() => handleCloseModal('addingStudents')}
              schoolid={schoolid}
              getClassesBySchoolId={getClassesBySchoolId}
              addStudents={addStudents}
            />
          )}

          {showModal.editStudents && (
            <EditStudentsModal
              show={showModal.editStudents}
              onHide={() => handleCloseModal('editStudents')}
              schoolid={schoolid}
              getStudentsBySchoolId={getStudentsBySchoolId}
              getClassesBySchoolId={getClassesBySchoolId}
              updateStudent={updateStudent}
              teacherid={teacherid}
              teacherName={name}
            />
          )}

          {showModal.deletingStudents && (
            <DeleteStudentsModal
              show={showModal.deletingStudents}
              onHide={() => handleCloseModal('deletingStudents')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
            />
          )}

          {showModal.studentTransfers && (
            <StudentTransfersModal
              show={showModal.studentTransfers}
              onHide={() => handleCloseModal('studentTransfers')}
              schoolid={schoolid}
            />
          )}

          {showModal.groupStudentTransfers && (
            <GroupStudentTransfersModal
              show={showModal.groupStudentTransfers}
              onHide={() => handleCloseModal('groupStudentTransfers')}
              schoolid={schoolid}
              getStudentsBySchool={getStudentsBySchoolId}
              getClassesBySchoolId={getClassesBySchoolId}
              transferStudents={bulkUpdateStudentClassId}
            />
          )}

          {showModal.repeatingStudents && (
            <RepeatingStudentsModal
              show={showModal.repeatingStudents}
              onHide={() => handleCloseModal('repeatingStudents')}
              schoolid={schoolid}
              teacherid={teacherid}
              teacherName={name}
            />
          )}

          {/* Class Management Modals */}
          {showModal.createClasses && (
            <CreateClassesModal
              show={showModal.createClasses}
              onHide={() => handleCloseModal('createClasses')}
              schoolid={schoolid}
              getTeachers={getTeachersBySchoolId}
              createBulkClasses={createBulkClasses}
            />
          )}

          {showModal.deleteClasses && (
            <DeleteClassesModal
              show={showModal.deleteClasses}
              onHide={() => handleCloseModal('deleteClasses')}
              schoolid={schoolid}
              softDeleteClass={softDeleteClass}
            />
          )}

          {showModal.classOwnership && (
            <ClassOwnershipModal
              show={showModal.classOwnership}
              onHide={() => handleCloseModal('classOwnership')}
              schoolid={schoolid}
              getTeachers={getTeachersBySchoolId}
              getClassesBySchoolId={getClassesBySchoolId}
              bulkRemoveOrReplaceClassOwner={handleBulkRemoveOrReplaceClassOwner}
            />
          )}

          {showModal.classroomEdit && (
            <ClassroomEditModal
              show={showModal.classroomEdit}
              onHide={() => handleCloseModal('classroomEdit')}
              schoolid={schoolid}
              getClassesBySchoolId={getClassesBySchoolId}
              updateClassName={handleUpdateClassName}
            />
          )}

          {!teacherMode && showModal.markClassAsFake && (
            <MarkClassAsFakeModal
              show={showModal.markClassAsFake}
              onHide={() => handleCloseModal('markClassAsFake')}
              schoolid={schoolid}
              getClassesBySchoolId={getClassesBySchoolId}
              updateTrialStatusBatch={updateTrialStatusBatch}
            />
          )}

          {showModal.gradeChangeManagement && (
            <GradeChangeManagementModal
              show={showModal.gradeChangeManagement}
              onHide={() => handleCloseModal('gradeChangeManagement')}
              schoolid={schoolid}
              getClassesBySchoolId={getClassesBySchoolId}
              bulkUpdateClassGrades={bulkUpdateClassGrades}
            />
          )}

          {showModal.classConversionMethod && (
            <ClassConversionMethodModal
              show={showModal.classConversionMethod}
              onHide={() => handleCloseModal('classConversionMethod')}
              schoolid={schoolid}
              getTeachersBySchoolId={getTeachersBySchoolId}
              createClassConversionMethod={createClassConversionMethod}
              updateClassConversionMethod={updateClassConversionMethod}
              getClassConversionMethodBySchoolId={getClassConversionMethodBySchoolId}
            />
          )}

          {!teacherMode && showModal.classTransitionWorkflow && (
            <ClassTransitionWorkflowModal
              show={showModal.classTransitionWorkflow}
              onHide={() => handleCloseModal('classTransitionWorkflow')}
              schoolid={schoolid}
            />
          )}

          {/* Communication Modals */}
          {showModal.sendingLogins && (
            <SendStudentLoginsModal
              show={showModal.sendingLogins}
              onHide={() => handleCloseModal('sendingLogins')}
              schoolid={schoolid}
              getQR={getQR}
              getClasses={getClassesBySchoolId}
            />
          )}

          {/* Assessment Comparison Modals - Staff only */}
          {!teacherMode && showModal.repeatingStudentComparison && (
            <RepeatingStudentComparisonModal
              show={showModal.repeatingStudentComparison}
              onHide={() => handleCloseModal('repeatingStudentComparison')}
              schoolid={schoolid}
            />
          )}

          {!teacherMode && showModal.retakeScreeningComparison && (
            <RetakeScreeningComparisonModal
              show={showModal.retakeScreeningComparison}
              onHide={() => handleCloseModal('retakeScreeningComparison')}
              schoolid={schoolid}
            />
          )}

          {!teacherMode && showModal.retakeTaskComparison && (
            <RetakeTaskComparisonModal
              show={showModal.retakeTaskComparison}
              onHide={() => handleCloseModal('retakeTaskComparison')}
              schoolid={schoolid}
            />
          )}

          {!teacherMode && showModal.rtiComparison && (
            <RTIComparisonModal
              show={showModal.rtiComparison}
              onHide={() => handleCloseModal('rtiComparison')}
              schoolid={schoolid}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ClassAdmin;